module.exports = __webpack_public_path__ + "img/honor-2.5fe09206.png";